import { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

import { Spacing } from '@/constants/theme';

/**
 * Two-column grid for the inside/property tile screens. Children should be
 * <Tile /> elements; layout splits them across two columns left-to-right.
 */
export function TileGrid({ children }: { children: ReactNode[] }) {
  const items = children.filter(Boolean);
  const left: ReactNode[] = [];
  const right: ReactNode[] = [];
  items.forEach((c, i) => (i % 2 === 0 ? left : right).push(c));

  return (
    <View style={styles.row}>
      <View style={styles.col}>
        {left.map((c, i) => (
          <View key={`l-${i}`}>{c}</View>
        ))}
      </View>
      <View style={styles.col}>
        {right.map((c, i) => (
          <View key={`r-${i}`}>{c}</View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: Spacing.two,
    marginTop: Spacing.three,
  },
  col: {
    flex: 1,
    gap: Spacing.two,
  },
});
